import { render, staticRenderFns } from "./VistaCatecumenos.vue?vue&type=template&id=f641defa&scoped=true&"
import script from "./VistaCatecumenos.vue?vue&type=script&lang=js&"
export * from "./VistaCatecumenos.vue?vue&type=script&lang=js&"
import style0 from "./VistaCatecumenos.vue?vue&type=style&index=0&id=f641defa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f641defa",
  null
  
)

export default component.exports